import { render, staticRenderFns } from "./BottomNavigation.vue?vue&type=template&id=81915560"
import script from "./BottomNavigation.vue?vue&type=script&lang=ts"
export * from "./BottomNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports